import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'
import {HeaderUserMenu} from '../../../partials'
import {UserModel} from "../../../../app/modules/auth/models/UserModel";
import {shallowEqual, useSelector} from "react-redux";
import {RootState} from "../../../../setup";
import { Link, useHistory } from 'react-router-dom';
import { usePermissionChecker } from '../../../../app/hooks/PermissionChecker';
import { LIST_PERMISSIONS } from '../../../../app/constants/common';
import { isMobile } from '../../../../app/modules/common/helper';
import { ModalModel } from '../../../../app/models/CommonModel';
import PrinterNameModal from '../../../../app/components/Modal/PrinterNameModal';

const toolbarButtonMarginClass = 'ms-0 ms-lg-0',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const curPth = useHistory().location.pathname;
  const isDashboard = curPth.includes('dashboard') || curPth === '/';
  const isOrder = curPth.includes('orders/detail');
  const [printerNameModal, setPrinterNameModal] = useState<ModalModel>({
      show: false,
      mode: 'add',
  });

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.blur();
  };

  const topBarNav = () => {
    if (isDashboard) {
      return (
        <>
            <div className='hidden-mobile'>
                <Link onClick={handleLinkClick}
                  to={'/orders/detail'} className='btn btn-primary btn-sm' title='Bán hàng'>Bán hàng</Link>
                <Link onClick={handleLinkClick}
                   to={'/warehouse/receipt/detail'} className='btn btn-warning btn-sm ms-2' title='Nhập kho'>Nhập kho</Link>
                <Link onClick={handleLinkClick}
                   to={'/warehouse/inventory-check-sheet'} className='btn btn-success mx-2 btn-sm' title='Kiểm kho'>Kiểm kho</Link>
            </div>
            <div className='mobile-only'>
                <Link onClick={handleLinkClick}
                   to={'/orders/detail'} className='btn btn-primary btn-sm' title='Bán hàng'><i className='fas fa-cart-plus'/><br/><span className='fs-small'>Bán hàng</span></Link>
                <Link onClick={handleLinkClick}
                   to={'/warehouse/receipt/detail'} className='btn btn-warning btn-sm ms-2' title='Nhập kho'><i className='fas fa-cart-arrow-down'/><br/>Nhập kho</Link>
                <Link onClick={handleLinkClick}
                   to={'/warehouse/inventory-check-sheet'} className='btn btn-success mx-2 btn-sm' title='Kiểm kho'><i className='fas fa-pallet'/><br/>Kiểm kho</Link>
            </div>
          </>
      )
    }
    if (isOrder) {
      return (
        <>
            <div className='hidden-mobile'>
              <Link to={'/orders'} className='btn btn-primary btn-sm' title='Đơn hàng'>Đơn hàng</Link>
              <Link to={'/warehouse/inventory-delivery/list'} className='btn btn-warning btn-sm ms-2' title='Đơn hàng xuất'>Đơn hàng xuất</Link>
              <Link to={'/abilities/receipt-voucher'} className='btn btn-success mx-2 btn-sm' title='Phiếu thu'>Phiếu thu</Link>
            </div>
            <div className='mobile-only'>
              <Link to={'/orders'} className='btn btn-primary btn-sm' title='Đơn hàng'><i className='fas fa-cart-plus'/><br/><span className='fs-small'>Đơn hàng</span></Link>
              <Link to={'/warehouse/inventory-delivery/list'} className='btn btn-warning btn-sm ms-2' title='Đơn hàng xuất'><i className='fas fa-truck'/><br/>Đơn xuất</Link>
              <Link to={'/abilities/receipt-voucher'} className='btn btn-success mx-2 btn-sm' title='Phiếu thu'><i className='fas fa-money-check-alt'/><br/>Phiếu thu</Link>
            </div>
          </>
      )
    }

    if (curPth.includes('warehouse/receipt/detail')) {
      return (
        <>
          <div className='hidden-mobile'>
            <Link to={'/warehouse/receipt/list'} className='btn btn-warning btn-sm ms-2' title='Đơn hàng nhập'>Đơn nhập</Link>
            <Link to={'/debt/supplier'} className='btn btn-success ms-2 btn-sm' title='Phiếu chi'>Công nợ NCC</Link>
            <Link to={'/abilities/payment-voucher'} className='btn btn-success mx-2 btn-sm' title='Phiếu chi'>Phiếu chi</Link>
          </div>
          <div className='mobile-only'>
            <Link to={'/warehouse/receipt/list'} className='btn btn-warning btn-sm ms-2' title='Đơn hàng nhập'><i className='fas fa-cart-arrow-down'/><br/>Đơn nhập</Link>
            <Link to={'/debt/supplier'} className='btn btn-success ms-2 btn-sm' title='Phiếu chi'><i className='far fa-money-bill-alt'/><br/>Công nợ NCC</Link>
            <Link to={'/abilities/payment-voucher'} className='btn btn-success mx-2 btn-sm' title='Phiếu chi'><i className='fas fa-money-check-alt'/><br/>Phiếu chi</Link>
          </div>
        </>
      )
    }
    if (curPth.includes('warehouse/inventory-check-sheet')) {
      return (
        <>
            <div className='hidden-mobile'>
              <Link to={'/warehouse/list'} className='btn btn-warning btn-sm ms-2' title='Tồn kho'>Tồn kho</Link>
            </div>
            <div className='mobile-only'>
              <Link to={'/warehouse/list'} className='btn btn-warning btn-sm ms-2' title='Tồn kho'><i className='fas fa-pallet'/><br/>Tồn kho</Link>
            </div>
          </>
      )
    }
    
  }

  return (
    <div className='d-flex align-items-center flex-shrink-0'>
      {/* begin::User */}
      {topBarNav()}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <div className="symbol symbol-50px">
            <div className="symbol-label fs-2 fw-bold text-primary">{user.user_name?.[0] ?? ''}</div>
          </div>
        </div>
        <HeaderUserMenu/>
        {/* end::Toggle */}
        {!isMobile() && (
          <>
            <button type='button'
              title='Thiết lập tên máy in'
              onClick={() => setPrinterNameModal({...printerNameModal, show: true})}
              className='btn btn-sm px-4 ms-1 bg-light text-primary border shadow-sm'  
            >
              <i className='bi bi-printer-fill'></i><i className='bi bi-gear-fill'></i>
            </button>
            <PrinterNameModal
              {...printerNameModal}
              onClose={() => setPrinterNameModal({...printerNameModal, show: false})}
            />
          </>
        )}
      </div>
      {/* end::User */}
    </div>
  )
}

export {Topbar}
